var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-l-15"},[_c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('pendings-recurrentes'),expression:"'pendings-recurrentes'"}],attrs:{"variant":"primary"}},[_vm._v(" Recurrentes ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }